import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SET_API_DATA } from "../redux/constants";
import { ApiContainer } from "../utils/api";

export const OTBContainer = () => {
  const { departmentId } = useParams();

  const { api } = ApiContainer();
  const dispatch = useDispatch();
  const OTBReportData = useSelector((state) => state?.api?.OTBReportData?.data);
  const OTBInfoData = useSelector((state) => state?.api?.OTBInfoData);

  const [availableDates, setAvailableDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isFirstRender, setIsFirstRender] = useState(true);

  const loaders = useSelector((state) => ({
    summaryLoader: state.api?.loader?.OTBReportData,
  }));
  const OTBInfoloaders = useSelector((state) => ({
    summaryLoader: state.api?.loader?.OTBInfoData,
  }));

  const getReportData = async (departmentId, date) => {
    const endPoint = `otb/report?department_id=${departmentId}${
      date ? `&tracking_date=${date}` : ""
    }`;

    const OTBData = await api({
      method: "GET",
      endPoint,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "OTBReportData",
    });

    if (OTBData?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          OTBReportData: OTBData?.data,
        },
      });
    }
  };

  const getOTBInfoData = async (departmentId) => {
    const OTBInfoData = await api({
      method: "GET",
      endPoint: `otb/info?department_id=${departmentId}`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "OTBInfoData",
    });

    if (OTBInfoData?.status) {
      const dates = OTBInfoData?.data?.dates || [];

      dispatch({
        type: SET_API_DATA,
        payload: {
          OTBInfoData,
        },
      });

      if (dates.length > 0) {
        await getReportData(departmentId, dates[0]?.value);
      }
    } else {
      dispatch({
        type: SET_API_DATA,
        payload: {
          OTBInfoData: null,
        },
      });
    }
  };

  useEffect(() => {
    if (!OTBInfoData || OTBInfoData?.data?.original_id !== departmentId) {
      getOTBInfoData(departmentId);
    }
  }, []);

  useEffect(() => {
    if (selectedDate) {
      if (!isFirstRender) {
        getReportData(departmentId, selectedDate);
      } else {
        setIsFirstRender(false);
      }
    }
  }, [selectedDate]);
  useEffect(() => {
    if (OTBInfoData && OTBInfoData?.data?.original_id === departmentId) {
      setAvailableDates(OTBInfoData?.data?.dates);
      setSelectedDate(OTBInfoData?.data?.dates[0]?.value);
    }
  }, [OTBInfoData]);

  return {
    OTBReportData,
    loaders,
    getReportData,
    OTBInfoData,
    OTBInfoloaders,
    availableDates,
    selectedDate,
    setSelectedDate,
    setAvailableDates,
  };
};
